module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-26.1d56f43a.png";